export default __webpack_public_path__ + "static/ant-fraud-d2639aaab105c3f7a0c9081a6444ef92.png";